module.exports = __webpack_public_path__ + "img/2.68b958d2.jpg";